import LimitationRoleRow from './LimitationRoleRow';

export default LimitationRoleRow;
